module.exports = __webpack_public_path__ + "static/media/swiggy-logo.c92b4d42.jpg";